export const bingKey =
    "tKmS2iaSrJeMANicuLRY~G3ZokY5DV1NIvzr9sFbfKw~AtGFQsTkIaigafYFVsGkHYVi-8bq3rDuRUH4tZoX7Ct4CwHDuwrgOzaQhziCu3x3";
export const mapBoxKey =
    "pk.eyJ1IjoibWNzY2xvdWQiLCJhIjoiY2s1NTc1Y25jMDEwMDNlbzV1MHF3YjhsNCJ9.Ks_mTaNJ1h73R6vkQXw52g";
